import React from "react";

export const useIsSticky = (navTopRef: React.MutableRefObject<HTMLDivElement | null>): boolean => {
  const [isSticky, setIsSticky] = React.useState<boolean>(false);

  React.useEffect(() => {
    const checkIfSticky = () => {
      const navTop = navTopRef.current;
      if (navTop) {
        // try to find the Sticky wrapper component (V2 pattern)
        const stickyWrapper = navTop.closest("[data-sticky]");
        if (stickyWrapper) {
          // V2 Sticky component pattern: use marker element
          const marker = stickyWrapper.nextElementSibling;
          if (marker) {
            const stickyRect = stickyWrapper.getBoundingClientRect();
            const markerRect = marker.getBoundingClientRect();

            // Get the computed margin-top to account for negative margins
            const computedStyle = window.getComputedStyle(navTop);
            const marginTop = parseFloat(computedStyle.marginTop) || 0;

            // the marker marks the original position of the element in the document flow.
            // when not stuck: marker and sticky element are at the same position (markerRect.top >= stickyRect.top)
            // when stuck: sticky element is held at the top while marker scrolls up past it (markerRect.top < stickyRect.top)
            // we need to account for negative margin which offsets the element visually
            // add +1 threshold to account for sub-pixel rendering differences
            setIsSticky(markerRect.top < stickyRect.top - marginTop + 1);
          }
        } else {
          // V1 pattern: simple check if element has reached the top of viewport
          // this works for NavGroup which doesn't have peekaboo headers affecting it
          const rect = navTop.getBoundingClientRect();
          setIsSticky(Math.floor(rect.top) <= 0);
        }
      }
    };

    checkIfSticky();

    window.addEventListener("scroll", checkIfSticky);
    window.addEventListener("resize", checkIfSticky);

    return () => {
      window.removeEventListener("scroll", checkIfSticky);
      window.removeEventListener("resize", checkIfSticky);
    };
  }, [navTopRef]);

  return isSticky;
};
